import { useLanguageContext } from "../../../context/LanguageContext";
import MessagebirdConfigsPage from "../../../pages/integrations/messagebird_configs/MessagebirdConfigsPage";
import { useMessagebirdConfigsRouteValidator } from "../../validators/integrations/messagebird_configs/MessagebirdConfigsRouteValidator";
import { RouteConfig } from "../RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useMessagebirdConfigsRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/integrations/messagebird")
    .setLabel(translate("eva.main.entities.messagebird_config"))
    .setValidator(useMessagebirdConfigsRouteValidator())
    .setPage(<MessagebirdConfigsPage />);
}

export default useMessagebirdConfigsRouteConfig;